/** Default OpenRouter platform surcharge when catalog markup fields are absent (5%). */
export const DEFAULT_OPENROUTER_MARKUP_RATE = 0.05;

/** ai-profiles tiered pricing threshold (tokens). */
export const PROFILE_TIERED_CONTEXT_THRESHOLD = 200_000;
